/* eslint-disabled */
import Branch from "./Branch";
import ItemProperty from "./ItemProperty";
import EngineMethodRequirement from "./EngineMethodRequirement";
import Item from "./Item";
import EngineMethod from "./EngineMethod";
import PrintableModel from "./PrintableModel";
import ItemTypeExtend from "@/entity/extends/ItemTypeExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class ItemType extends ItemTypeExtend {

    public id!: number;
    public name = '';
    public code = '';
    public icon? = '';
    public branch!: Branch;
    public properties: Array<ItemProperty> = [];
    public className? = '';
    public required?: boolean;
    public isRoot?: boolean;
    public requireIn: Array<EngineMethodRequirement> = [];
    public items: Array<Item> = [];
    public isPackApplier?: boolean;
    public aliasFromParent?: boolean = false;
    public grantsAccessTo?: string | null = null;
    public method!: EngineMethod;
    public details = [];
    public asaciWorkflow? = '';
    public printables: Array<PrintableModel> = [];
    public workflows: any[] = [];
    public uuid? = '';
    public createdAt?: Date;
    public updatedAt?: Date;
    public createBy? = '';
    public updateBy? = '';
    public removeBy? = '';
    public createdFromIp? = '';
    public updatedFromIp? = '';
    public ranking?: number;
    public deletedAt?: Date;

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.name = object.name;
            this.code = object.code;
            this.icon = object.icon;
            this.branch = (object.branch instanceof Branch) ? object.branch : object.branch ? new Branch(object.branch) : object.branch;
            hydrateCollection(object.properties, ItemProperty, this.properties);
            this.className = object.className;
            this.required = object.required;
            this.isRoot = object.isRoot;
            hydrateCollection(object.requireIn, EngineMethodRequirement, this.requireIn);
            hydrateCollection(object.items, Item, this.items);
            this.isPackApplier = object.isPackApplier;
            this.aliasFromParent = object.aliasFromParent || false;
            this.grantsAccessTo = object.grantsAccessTo || null;
            this.method = (object.method instanceof EngineMethod) ? object.method : object.method ? new EngineMethod(object.method) : object.method;
            this.details = object.details;
            this.asaciWorkflow = object.asaciWorkflow;
            this.workflows = object.workflows || [];
            hydrateCollection(object.printables, PrintableModel, this.printables);
            this.uuid = object.uuid;
            if (object.createdAt) {
                this.createdAt = new Date(object.createdAt);
            }
            if (object.updatedAt) {
                this.updatedAt = new Date(object.updatedAt);
            }
            this.createBy = object.createBy;
            this.updateBy = object.updateBy;
            this.removeBy = object.removeBy;
            this.createdFromIp = object.createdFromIp;
            this.updatedFromIp = object.updatedFromIp;
            this.ranking = object.ranking;
            if (object.deletedAt) {
                this.deletedAt = new Date(object.deletedAt);
            }
        }
        this.postConstruct()
    }

}
